import React from 'react';
import { MultiSelectData } from '../multi-select-modal/multi-select-modal';
import { SearchResultWrapper } from './multi-select-search-result.style';
import MultiRadioWithLabel from '../multi-radio-with-label/multi-radio-with-label';

interface Props {
    data?: MultiSelectData[];
    elName: string;
    searchTerm: string;
    handleSearchResultToggle: (data: MultiSelectData) => void
}

const MultiSelectSearchResult: React.FC<Props> = ({
    data,
    elName,
    searchTerm,
    handleSearchResultToggle
}) => {
    return (
        <SearchResultWrapper>
            {data?.map((item) => (
                <MultiRadioWithLabel
                    key={item.id}
                    id={String(item.id)}
                    label={item.displayName}
                    listName={`${elName}-search-list`}
                    searchTerm={searchTerm}
                    onToggle={() => handleSearchResultToggle(item)}
                />
            ))}
        </SearchResultWrapper>
    )
}

export default MultiSelectSearchResult;
